<div class="container mx-auto w-full max-w-[998px] px-3 py-9" *ngIf="cart">
  <div class="gap-x-6 md:flex" *ngIf="shopItems.length">
    <div class="mx-auto grid w-full flex-1 gap-y-5 pb-3">
      <p class="hidden text-xl font-bold text-primary-darkest lg:block">Cart</p>
      <!-- Product Order -->
      <div
        class="grid gap-y-5 rounded-lg border border-solid border-primary-dark p-5 pt-3 shadow-md lg:p-10"
        *ngFor="let shop of shopItems">
        <div>
          <div class="flex pb-2">
            <fa-icon class="text-primary-dark" [icon]="storeIcon"></fa-icon>
            <p class="ml-2 uppercase text-primary-darkest">
              {{ shop.shop_name }}
            </p>
          </div>
          <hr class="border-primary-dark" />
        </div>
        <div class="" *ngFor="let cartItem of shop.items">
          <div class="flex w-full gap-x-3">
            <picture class="flex-none">
              <img
                class="mx-auto h-28 w-28"
                [src]="cartItem.product_default_image_path[0].extra_small.path"
                alt="product" />
            </picture>
            <div class="w-full">
              <div>
                <p
                  class="text-sm font-medium uppercase text-amber-600 line-clamp-1">
                  {{ cartItem.product_name }}
                </p>
                <p *ngIf="cartItem.product_variant_name">
                  {{ cartItem.product_variant_name }}
                </p>
                <p class="text-xs">{{ cartItem.remaining_stock }} Pcs Left</p>
                <p class="font-bold text-rose-500">
                  {{ cartItem.unit_price | fcCurrency }}
                </p>
              </div>
              <div class="text-right">
                <button type="button" (click)="deleteCart(cartItem.id)">
                  <fa-icon
                    class="mr-4 text-xl text-primary-dark"
                    [icon]="trashIcon"></fa-icon>
                </button>
                <button
                  class="h-6 w-6 bg-primary-dark hover:bg-primary-md-dark hover:text-white md:h-10 md:w-12"
                  (click)="onChangeQty(false, cartItem.id, cartItem.quantity)">
                  -
                </button>
                <input
                  type="number"
                  class="h-6 w-8 border border-primary-dark text-center focus:outline-none md:h-10 md:w-14"
                  (keyup)="onChangeQtyByInput(cartItem.id, cartItem.quantity)"
                  [(ngModel)]="cartItem.quantity" />
                <button
                  class="h-6 w-6 bg-primary-dark hover:bg-primary-md-dark hover:text-white md:h-10 md:w-12"
                  (click)="onChangeQty(true, cartItem.id, cartItem.quantity)">
                  +
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Shopping Summary -->
    <div class="mx-auto w-full pt-5 text-left md:w-[300px] md:pt-0">
      <p class="pb-3 text-xl font-bold text-primary-darkest">
        Shopping Summary
      </p>

      <div class="pt-3">
        <div class="rounded-lg border border-solid p-2">
          <div class="grid grid-cols-2 pb-3">
            <p class="font-semibold">Total Price</p>
            <p class="text-right font-semibold">
              {{ cart.totalCartPrice | fcCurrency }}
            </p>
          </div>
          <button
            class="w-full rounded-lg bg-primary-dark p-3 text-center hover:bg-primary-md-dark hover:text-white"
            (click)="navigateToCheckout()">
            Checkout
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- If cart empty -->
  <div
    class="mx-auto mt-1 w-full max-w-[500px] text-center text-primary-darkest"
    *ngIf="!shopItems.length">
    <img
      src="assets/images/product/no-result-search-dummy.png"
      class="illust mx-auto" />
    <div class="text-lg font-bold">Your cart is empty</div>
    <div class="mx-auto">Let's fill in your wishes!</div>
  </div>
</div>
